{
  "name": "shell",
  "version": "0.10.1021",
  "main": "tools/start.js",
  "engines": {
    "node": "^20.19.0 || >=22.12.0",
    "pnpm": ">=10.28.0"
  },
  "packageManager": "pnpm@10.28.1",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "vite build",
    "build:deadfile": "ENABLE_DEADFILE=true vite build",
    "watch": "vite build --watch",
    "tdd": "npm run playwright:ui",
    "preview": "vite preview",
    "serve": "bash script/build.sh e2e && TARGET_ENV=e2e vite preview",
    "serve:dev": "bash script/build.sh dev && vite preview",
    "debug": "vite build --mode development && vite preview --port 8080",
    "test": "TZ=UTC SKIP_SOURCEMAPS=true vitest run",
    "test:watch": "vitest",
    "test:ci": "TZ=UTC SKIP_SOURCEMAPS=true vitest run --retry=3 --coverage",
    "test:ui": "vitest --ui",
    "eslint": "eslint --config eslint.config.mjs",
    "lint": "npm run lint:shell && npm run lint:test && npm run lint:e2e",
    "lint:fix": "npm run lint:shell -- --fix && npm run lint:test -- --fix && npm run lint:e2e -- --fix",
    "lint:shell": "npm run eslint -- './src/**/*.{js,jsx}' --max-warnings 0",
    "lint:test": "npm run eslint -- './tests/**/*.{js,jsx}' --max-warnings 0",
    "lint:e2e": "npm run eslint -- './{e2e,componentTest}/**/*.{js,jsx}' --max-warnings 0",
    "prepare": "cd .. && husky ./shell/.husky",
    "pre-commit": "lint-staged",
    "prettier": "prettier --ignore-path .gitignore './src/**/*.{js,jsx}'",
    "check-format": "npm run prettier -- --list-different",
    "format": "npm run prettier -- --write",
    "validate": "npm-run-all --parallel check-format lint",
    "playwright:compile": "tsc --incremental -p ./e2e/tsconfig.json",
    "playwright:server": "npm run playwright:app:dev",
    "playwright:run": "npx playwright test",
    "playwright:run:connected": "PW_NO_WEBSERVER=1 npx playwright test",
    "playwright:headed": "npx playwright test --headed",
    "playwright:headed:connected": "PW_NO_WEBSERVER=1 npx playwright test --headed",
    "playwright:app:dev": "TARGET_ENV=e2e SKIP_S3_UPLOAD=true SKIP_SOURCEMAPS=true vite --host 0.0.0.0 --port 4173 --strictPort",
    "playwright:ui": "start-server-and-test playwright:app:dev http://localhost:4173 \"npx playwright test --ui\"",
    "playwright:ui:connected": "PW_NO_WEBSERVER=1 npx playwright test --ui",
    "playwright:ui:stable": "bash script/build.sh e2e && TARGET_ENV=e2e start-server-and-test preview http://localhost:4173 \"npx playwright test --ui\"",
    "playwright:ci": "bash script/build.sh e2e && TARGET_ENV=e2e start-server-and-test preview http://localhost:4173 \"npm run playwright:run -- --shard=$SHARD/5\"",
    "playwright:ci:prebuilt": "TARGET_ENV=e2e start-server-and-test preview http://localhost:4173 \"npm run playwright:run -- --shard=$SHARD/5\"",
    "playwright:dev": "start-server-and-test playwright:app:dev http://localhost:4173 playwright:headed",
    "playwright:dev:headless": "start-server-and-test playwright:app:dev http://localhost:4173 playwright:run",
    "playwright:dev:stable": "bash script/build.sh e2e && TARGET_ENV=e2e start-server-and-test preview http://localhost:4173 playwright:headed",
    "playwright:dev:headless:stable": "bash script/build.sh e2e && TARGET_ENV=e2e start-server-and-test preview http://localhost:4173 playwright:run",
    "test-ct": "cross-env NODE_OPTIONS=--max-old-space-size=4096 playwright test -c playwright-ct.config.cjs",
    "postinstall": "node script/xstate5-react-script.js"
  },
  "dependencies": {
    "@codemirror/lang-javascript": "^6.1.7",
    "@codemirror/lint": "^6.2.1",
    "@codemirror/state": "^6.2.0",
    "@codemirror/view": "^6.11.0",
    "@crazyegginc/ai": "^0.9.1013",
    "@crazyegginc/compatibility-checker": "0.1.67",
    "@crazyegginc/fingerprint": "1.0.13",
    "@crazyegginc/hatch": "3.0.167",
    "@crazyegginc/js-utils": "1.0.8",
    "@crazyegginc/react-multi-email-input": "^0.1.7",
    "@crazyegginc/video-api": "^0.0.44",
    "@datadog/browser-rum": "4.42.0",
    "@headlessui/react": "2.2.8",
    "@honeybadger-io/js": "^6.12.3",
    "@lukemorales/query-key-factory": "^1.3.4",
    "@popperjs/core": "^2.10.2",
    "@semcore/app-center-js-sdk": "^0.0.7",
    "@tanstack/react-query": "^4.43.0",
    "@tanstack/react-virtual": "^3.0.0-beta.54",
    "@ungap/structured-clone": "^1.2.0",
    "@urql/core": "^4.0.7",
    "@xstate/react": "^3.2.2",
    "@xstate5/react": "npm:@xstate/react@^4.1.1",
    "broadcast-channel": "^5.1.0",
    "chart.js": "^4.3.0",
    "classnames": "^2.3.1",
    "codemirror": "^6.0.1",
    "codemirror-readonly-ranges": "^0.1.0-alpha.1",
    "credit-card-type": "^10.0.1",
    "date-fns": "^2.30.0",
    "date-fns-tz": "^2.0.0",
    "dexie": "3.2.3",
    "dexie-react-hooks": "^1.1.1",
    "dompurify": "^3.1.7",
    "emoji-js": "^3.6.0",
    "eslint-linter-browserify": "^8.40.0",
    "fast-equals": "^5.0.1",
    "flat": "^5.0.2",
    "formik": "^2.2.9",
    "fs-extra": "^11.2.0",
    "graphql": "^16.8.1",
    "graphql-ws": "^5.12.1",
    "immer": "^10.0.1",
    "jotai": "^2.15.1",
    "jotai-xstate": "^0.3.0",
    "jsondiffpatch": "^0.4.1",
    "jwt-decode": "^3.1.2",
    "linkify-react": "^4.1.1",
    "linkifyjs": "^4.1.1",
    "mark.js": "^8.11.1",
    "nanoid": "^4.0.2",
    "object-hash": "^3.0.0",
    "react": "^18.3.1",
    "react-chartjs-2": "^5.2.0",
    "react-country-flag": "^3.1.0",
    "react-dnd": "^16.0.1",
    "react-dnd-html5-backend": "^16.0.1",
    "react-dom": "^18.3.1",
    "react-fast-compare": "^3.2.0",
    "react-helmet": "^6.1.0",
    "react-hotkeys-hook": "^4.5.0",
    "react-number-format": "^5.4.2",
    "react-popper": "^2.2.5",
    "react-router-dom": "^6.30.1",
    "react-scrollbar-size": "^5.0.0",
    "react-select": "^5.7.3",
    "react-use-scroll-position": "^2.0.0",
    "use-resize-observer": "^9.0.0",
    "uuid": "^9.0.0",
    "xstate": "^4.38.2",
    "xstate5": "npm:xstate@^5.11.0",
    "yup": "^0.32.11"
  },
  "devDependencies": {
    "@crazyegginc/eslint-plugin-hatch": "^0.0.5",
    "@eslint/compat": "^1.2.2",
    "@eslint/eslintrc": "^3.1.0",
    "@eslint/js": "^9.14.0",
    "@faker-js/faker": "^10.0.0",
    "@jackfranklin/test-data-bot": "^2.1.0",
    "@playwright/experimental-ct-react": "1.48.2",
    "@playwright/test": "1.48.2",
    "@remix-run/web-fetch": "^4.3.4",
    "@svgr/plugin-jsx": "^6.2.1",
    "@svgr/plugin-svgo": "^6.2.0",
    "@tanstack/eslint-plugin-query": "5.90.2",
    "@testing-library/dom": "^10.4.0",
    "@testing-library/jest-dom": "^6.6.3",
    "@testing-library/react": "^16.0.1",
    "@testing-library/user-event": "^14.5.2",
    "@vitejs/plugin-react": "^6.0.1",
    "@vitejs/plugin-react-swc": "^4.3.0",
    "@vitest/coverage-v8": "^4.1.0",
    "@vitest/ui": "^4.1.0",
    "autoprefixer": "^10.4.7",
    "aws-sdk": "^2.1373.0",
    "cli-progress": "^3.11.1",
    "core-js": "^3.47.0",
    "cross-env": "^7.0.3",
    "esbuild": "^0.27.0",
    "eslint": "^9.13.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-config-react": "^1.1.7",
    "eslint-plugin-import": "^2.26.0",
    "eslint-plugin-jest-dom": "^5.4.0",
    "eslint-plugin-jsx-a11y": "^6.6.1",
    "eslint-plugin-playwright": "^2.0.0",
    "eslint-plugin-prettier": "^5.2.1",
    "eslint-plugin-react": "^7.31.11",
    "eslint-plugin-react-hooks": "^6.1.1",
    "eslint-plugin-react-refresh": "^0.4.7",
    "eslint-plugin-testing-library": "^7.15.1",
    "form-data": "^4.0.0",
    "globals": "^15.11.0",
    "husky": "^8.0.1",
    "jsdom": "25.0.1",
    "jsdom-testing-mocks": "^1.15.2",
    "jsonwebtoken": "^9.0.2",
    "lint-staged": "^13.2.2",
    "mime": "^3.0.0",
    "msw": "2.6.6",
    "npm-run-all": "^4.1.5",
    "postcss": "^8.4.23",
    "postcss-preset-env": "^8.3.2",
    "postcss-scss": "^4.0.4",
    "postcss-strip-inline-comments": "^0.1.5",
    "prettier": "^3.3.3",
    "prettier-plugin-tailwindcss": "^0.6.8",
    "sass": "^1.62.1",
    "start-server-and-test": "^2.0.3",
    "tailwindcss": "3.3.2",
    "typescript": "^5.9.3",
    "vite": "^8.0.0",
    "vite-plugin-compression": "^0.5.1",
    "vite-plugin-deadfile": "^1.3.0",
    "vite-plugin-html": "^3.2.0",
    "vite-plugin-svgr": "^4.5.0",
    "vitest": "^4.1.0"
  },
  "pnpm": {
    "peerDependencyRules": {
      "allowedVersions": {
        "@babel/core": "^7.28.4",
        "@svgr/core": "^8.1.0",
        "vite": "^8.0.0",
        "xstate": "^4.38.3 || ^5.18.2"
      }
    }
  },
  "lint-staged": {
    "src/**/*.{js,jsx,cjs}": [
      "npm run eslint -- --fix --max-warnings 0"
    ],
    "tests/**/*.{js,jsx,cjs}": [
      "npm run eslint -- --fix --max-warnings 0"
    ],
    "e2e/**/*.{js,jsx,cjs}": [
      "npm run eslint -- --fix --max-warnings 0"
    ]
  }
}
